export const formatPath = (path: string) => {
    const splitPath = path.split('/');
    const sliceSplitPath = splitPath.slice(0, splitPath.length - 1);

    return sliceSplitPath.join(' / ');
};